import {TRANSLATION, Yup} from '@/imports-files/components/add-to-job-modal';

export const CANDIDATE_EMAIL_VALUES =  {
                                          email: {
                                                      purpose: '',
                                                      to:'',
                                                      cc:[],
                                                      subject: '',
                                                      body: '',
                                                      reply_to:'',
                                                      references:'',
                                                      forward:'',
                                                      attachments:[],
                                                      comm_detail_id:'',
                                                      entity_type: ''
                                                 }
                                      }


export const CANDIDATE_EMAIL_VALIDATION =  Yup.object({
                                                            email: Yup.object({
                                                                                    subject: Yup.string().required(TRANSLATION('errors:required')),
                                                                                    body: Yup.string().required(TRANSLATION('errors:required')),
                                                                                    reply_to: Yup.string()
                                                                              })
                                                      })


                                                      
export const TEXTS = (t) => {

      return {
                  send_email:{ heading: t('modal:email_modal:send_email_heading') },
                  job_application:{ heading: t('modal:email_modal:send_email_heading')},
                  reply_email:{ heading: t('modal:email_modal:reply_email_heading') },
                  To: t('modal:email_modal:to'),
                  reply_to: t('modal:email_modal:reply_to'),
                  Email_Body: t('modal:email_modal:email_body'),
                  Subject: t('modal:email_modal:subject'),
                  CC: t('modal:email_modal:cc'),
                  Attachment: t('modal:email_modal:attachment'),
                  ADD_DOCUMENT: t('modal:email_modal:add_document'),
                  Save: t('modal:email_modal:save'),
                  purpose: t('modal:email_modal:purpose'),
                  tag_heading:  t('modal:email_modal:tag_heading'),
                  insert_token: 'insert_token'
            }
      }